<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <label class="generalLabel" for="vendorCheck">Se va a aceptar la {{ this.business ? 'gestión' : 'revisión' }} del
      contrato, pulse "Confirmar" para
      continuar.</label>
    <button class="btn btn-primary generalPrimaryButton float-right" data-dismiss="modal" aria-label="Close"
      @click="accept()">Confirmar</button>
  </Modal>
</template>

<script>

import Modal from '../../../Shared/Modal.vue';
import axios from 'axios';
export default {
  name: 'AcceptContract',
  props: [
    'id',
    'modalTitle',
    'class',
    'contractId',
    'business',
    'contractIndex'
  ],
  data() {
    return {
      classes: this.class,
    }
  },
  components: {
    Modal,
  },
  methods: {
    accept() {
      if (this.business) {
        let bodyToSend = {
          businessContractId: this.contractId,
          status: 'accepted',
        }
        axios.patch(`/business/update-contract`, bodyToSend)
          .then(() => {
            let bodyStatus = {
              "contractIndex": this.contractIndex,
              "cancellation": bodyToSend.status,
              "description": 'BUSINESS ACEPTADO'
            }
            this.$emit("refreshContractList", bodyStatus);
          });
      } else {
        let bodyToSend = {
          contractId: this.contractId,
          status: 'ACCEPTED',
          blacklist: false
        }
        axios.put(`/contract/validation/update-status`, bodyToSend)
          .then(() => {
            let bodyStatus = {
              "contractIndex": this.contractIndex,
              "cancellation": bodyToSend.status,
              "description": 'ACEPTADO'
            }
            this.$emit("refreshContractList", bodyStatus);
          });
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"></style>
